<template>
  <div>
    <h1>Keycloak</h1>
    <v-data-table
      :pagination.sync="pagination"
      :headers="headers"
      :items="roleRepresentations"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>{{ props.item.name }}</td>
        </tr>
      </template>
    </v-data-table>
    <v-btn @click="updateRoleRepresentations">Create role representations</v-btn>
  </div>
</template>

<script>
import nbmlaw from "@/api/nbmlaw";
export default {
  name: "Keycloak",
  metaInfo() {
    return {
      title: "Keycloak",
      titleTemplate: "%s - Directory - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  data() {
    return {
      roleRepresentations: [],
      headers: [
        {
          text: "Name",
          value: "name"
        }
      ],
      pagination: {
        rowsPerPage: 10,
        sortBy: "name",
        descending: false
      }
    };
  },
  methods: {
    fetchRoleRepresentations() {
      nbmlaw.get(`/cors/admin/directory/roleRepresentations`).then(response => {
        // console.log(response.data);
        this.roleRepresentations = response.data;
      });
    },
    updateRoleRepresentations() {
      nbmlaw.put(`/cors/admin/directory/roleRepresentations`, null).then(() => {
        // console.log(response.data);
        this.fetchRoleRepresentations();
      });
    }
  },
  created() {
    this.fetchRoleRepresentations();
  }
};
</script>
